import React, { Component } from 'react';
import mainLogo from '../assets/img/Eu.jpeg';

import { Header } from '../components/Header';
import { Footer } from '../components/footer';
import { About } from './About';
import { Project } from './Project';
import { Contact } from './Contact';
import { useTranslation } from 'react-i18next';
import hoistStatics from 'hoist-non-react-statics';
import { withTranslation } from 'react-i18next';

function Home(ts) {
    const { i18n } = ts;
    const texto = i18n['t']
    const obj = i18n['i18n']
    console.log(i18n, "home")

    return (
        <>
            <Header i18n={i18n}/>
            <section id="home" className="text-gray-700 body-font">
                <div className="container mx-auto flex px-5 py-24 md:py-48 md:flex-row flex-col items-center">
                    <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
                        <h1 className="title-font sm:text-6xl text-3xl mb-4 font-medium text-gray-900">
                            {texto('hi')}<br />
                            {texto('im_willian')}<br />
                            {texto('fullstack_developer')}
                        </h1 >
                        <p className="mb-8 leading-relaxed">
                            {texto('title')}
                        </p>
                        <div className="flex justify-center">
                        </div>
                    </div>
                    <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
                        <img src={mainLogo} className="rounded-full" />
                    </div>
                </div>
            </section>

            <About i18n={i18n}/>

            <Project i18n={i18n}/>

            <Contact i18n={i18n}/>

            <Footer i18n={i18n}/>

        </>
    )
}

export default Home;
